import React from 'react';
import { motion } from 'framer-motion';
import { Construction } from 'lucide-react'; // Icon
import { Helmet } from 'react-helmet-async'; // Import Helmet

// Animation Variants
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const PortfolioPage = () => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={fadeInUp} // Single fade-in for the whole page
      className="text-center py-16 md:py-24"
    >
      <Helmet>
        <title>Portfolio Webdesign Projecten | CylostreamWeb Limburg</title>
        <meta name="description" content="Bekijk het portfolio van CylostreamWeb - voorbeelden van webdesign en webontwikkeling projecten gerealiseerd in Limburg en België." />
        <meta name="keywords" content="portfolio webdesign, webdesign voorbeelden, website projecten Limburg, KMO websites België, CylostreamWeb" />
        <meta property="og:title" content="Portfolio Webdesign Projecten | CylostreamWeb Limburg" />
        <meta property="og:description" content="Bekijk het portfolio van CylostreamWeb - voorbeelden van webdesign en webontwikkeling projecten gerealiseerd in Limburg en België." />
        <link rel="canonical" href="https://www.cylostream.com/portfolio" /> 
      </Helmet>

      <Construction size={64} className="mx-auto mb-6 text-primary" />
      <h1 className="text-4xl md:text-5xl font-bold mb-4">
        Ons <span className="inline-block bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent">Werk</span>
      </h1>
      <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
        We werken hard aan het samenstellen van ons portfolio. Kom binnenkort terug om enkele van onze projecten te bekijken!
      </p>
      {/* Optional: Add a CTA button back to home or contact */}
      {/* 
      <Button asChild variant="outline" className="mt-8">
        <Link to="/">Terug naar Home</Link>
      </Button>
      */}
    </motion.div>
  );
};

export default PortfolioPage; 